import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/shared/user.service';
import { Onboarding } from 'src/app/shared/onboarding.model';
import { Router } from '@angular/router';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.css']
})
export class OnboardingComponent implements OnInit {
  @ViewChild('loaderRef') loader: ElementRef;
  fileToUpload: File = null;
  childcheckbox :boolean =false;
  parentcheckbox:boolean = false;
  error_message:string="";
  error_exist:boolean = false;

  constructor(public userService: UserService,private router: Router) {
    userService.onboarding = new Onboarding();
   }

   
  ngOnInit(): void {
  }
  submit(onboardingForm:NgForm){
    document.getElementById('loader').style.display='block';
    this.userService.createTenant(this.fileToUpload).then((res:Onboarding)=>{
      console.log('result',res)
      this.error_exist = false;
      this.error_message  = '';
      this.userService.onboardingDone = true;
      this.userService.sendMail(res.id).then((r)=>{
        document.getElementById('loader').style.display='none';
        this.router.navigate(['/app/onboardingsuccess']);
      }).catch((error)=>{
        this.error_exist = true;
        this.error_message = 'An Unknown Error Occured while sending the email confirmation mail!!';
        document.getElementById('loader').style.display='none';
       // this.router.navigate(['/app/onboardingsuccess']);
      }).finally(()=>{
        document.getElementById('loader').style.display='none';
      });
      
    }).catch((r)=>{
      this.error_exist = true;
      if(r.hasOwnProperty('error')){
        if(r.error.hasOwnProperty('error') && r.error.hasOwnProperty('message')){
          this.error_message = r.error.message;
        }
        else{
          this.error_message = 'An Unknown Error Occured while saving the details!!';
        }
      }
      else{
        this.error_message = 'An Unknown Error Occured while saving the details!!';
      }

    }).finally(()=>{
      document.getElementById('loader').style.display='none';
      window.scroll(0,0);
    });
  }
  handleFileInput(files: FileList){
    this.fileToUpload = files.item(0);
    document.getElementById('companyLogoLabel').innerHTML = this.fileToUpload.name;
  }
  onCheckboxChange(e) {
    if (e.target.checked) {
      this.childcheckbox = true;
    } else {
      this.childcheckbox = false;
    }
  }
}
